import React from 'react';
import { Scissors, MessageSquare, BarChart2, Mic } from 'lucide-react';
import './BentoGrid.css';

export const BentoGrid = () => {
    return (
        <section className="bento-section">
            <div className="bento-header">
                <span className="bento-preheader">Why Choose CutIQ?</span>
                <h2 className="bento-title">Everything you need to <br />dominate content.</h2>
            </div>

            <div className="bento-grid">
                {/* Smart Clips - The Main Feature */}
                <div className="bento-card bento-item-1">
                    <div className="bento-content">
                        <div className="bento-icon-wrapper">
                            <Scissors size={32} />
                        </div>
                        <h3 className="bento-card-title">Smart Clips</h3>
                        <p className="bento-card-desc">
                            Instantly identify and extract the most viral moments from long-form content.
                            Our AI analyzes engagement potential to give you clips that convert.
                        </p>
                    </div>
                    {/* Visual element removed */}
                </div>

                {/* Rants - The Vertical Feature */}
                <div className="bento-card bento-item-2">
                    <div className="bento-content">
                        <div className="bento-icon-wrapper">
                            <MessageSquare size={32} />
                        </div>
                        <h3 className="bento-card-title">Rants</h3>
                        <p className="bento-card-desc">
                            Turn raw thoughts into polished, engaging video rants.
                            Perfect for commentary and opinion content.
                        </p>
                    </div>
                    {/* Visual element removed */}
                </div>

                {/* Ranked - Feature 3 */}
                <div className="bento-card bento-item-3">
                    <div className="bento-content">
                        <div className="bento-icon-wrapper">
                            <BarChart2 size={32} />
                        </div>
                        <h3 className="bento-card-title">Ranked</h3>
                        <p className="bento-card-desc">
                            Create engaging "Top 10" style ranking videos with automated visuals and voiceovers.
                        </p>
                    </div>
                </div>

                {/* Voice Clone - Feature 4 */}
                <div className="bento-card bento-item-4">
                    <div className="bento-content">
                        <div className="bento-icon-wrapper">
                            <Mic size={32} />
                        </div>
                        <h3 className="bento-card-title">Voice Clone</h3>
                        <p className="bento-card-desc">
                            Clone your own voice for authentic, effortless narration across all your videos.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};
